module.exports = __webpack_public_path__ + "static/media/timebased-icon.134cf8a9.png";